import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Container, getToken, ZIndex } from '@optimus-web/core';

const StickyContainerElement = styled(Container)`
    background: ${getToken('backgroundStaticFlat')};
`;

export const StickyContainer = ({ children }: PropsWithChildren<{}>) => (
    <StickyContainerElement position="sticky" top="0" zIndex={ZIndex.High}>
        {children}
    </StickyContainerElement>
);
